import { ICreatDiarioObraUseCase } from "../../../presentation/useCases/create/create_diario_obra_use_case";
import { IDiarioObraRepository } from "../../repositories/diario_obra_repository";

// CreateDiarioObraUseCase

export class CreateDiarioObraUseCase implements ICreatDiarioObraUseCase {
  constructor(private readonly repository: IDiarioObraRepository) {}

  async createDiarioObra(
    IdCentroCusto: number | null,
    IdCliente: number | null,
    IdClienteCentroCusto: number | null,
    IdFuncionarioResponsavel: number | null,
    IdFuncionarioAprovador: number | null,
    NumeroDocumento: string | null,
    DataCadastro: Date | null,
    ResponsavelPor: string | null,
    AprovadoPor: string | null,
    CondicaoTempo: string | null,
    DiaPraticavel: number | null,
    Observacao: string | null,
    Status: number | null,
    JustificativaDia: string | null,
    AssinaturaCliente: string | null,
    AssinaturaConstrutora: string | null,
    NroDiario: number | null,
    DataAlteracao: Date | null,
    HorarioTrabalhoDe: string | null,
    HorarioTrabalhoAte: string | null,
    HorarioAlmocoDe: string | null,
    HorarioAlmocoAte: string | null,
  ): Promise<number> {
    const response = await this.repository.createDiarioObra(
      IdCentroCusto,
      IdCliente,
      IdClienteCentroCusto,
      IdFuncionarioResponsavel,
      IdFuncionarioAprovador,
      NumeroDocumento,
      DataCadastro,
      ResponsavelPor,
      AprovadoPor,
      CondicaoTempo,
      DiaPraticavel,
      Observacao,
      Status,
      JustificativaDia,
      AssinaturaCliente,
      AssinaturaConstrutora,
      NroDiario,
      DataAlteracao,
      HorarioTrabalhoDe,
      HorarioTrabalhoAte,
      HorarioAlmocoDe,
      HorarioAlmocoAte,
    );
    return response.idDiarioObras;
  }
}
